// extracted by mini-css-extract-plugin
module.exports = {"box":"_2-HFH","modalBox":"_3f7tE","header":"_37Rf7","close":"_25BeY","back":"_2oMM4"};